<template>
    <div class="row">
        <div class="content">
            <div class="text-center py-3">
                <div class="py-3">
                    <i class="material-icons" style="font-size: 64px;">contacts</i>
                </div>
                <h1 class="h3 font-w700 mb-2">No Contacts found</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactList"
    }
</script>

<style scoped>

</style>
